import { cn } from '@/lib/utils';

// Canonical Life Leverage OS brand icon (same asset family as the Google Play icon).
// The source PNG is pre-rendered at 96px and 192px so it stays crisp on HiDPI
// screens without shipping the 1.4 MB master file.
const SIZES = {
  sm: 'h-9 w-9',
  md: 'h-11 w-11',
  lg: 'h-12 w-12',
};

export const BrandLogo = ({ size = 'lg', className, withText = false, textClassName }) => {
  const icon = (
    <img
      src="/brand/ll-icon-96.png"
      srcSet="/brand/ll-icon-96.png 1x, /brand/ll-icon-192.png 2x"
      alt="Life Leverage OS"
      width={96}
      height={96}
      decoding="async"
      draggable={false}
      data-testid="brand-logo"
      className={cn('brand-logo-tile shrink-0 select-none rounded-2xl object-contain', SIZES[size] || SIZES.lg, className)}
    />
  );

  if (!withText) return icon;

  return (
    <div className="flex items-center gap-3">
      {icon}
      <span className={cn('text-sm font-medium tracking-wide text-foreground/60', textClassName)}>LIFE LEVERAGE OS</span>
    </div>
  );
};
